// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"21122400","796":"ecd82334","974":"c8ddbc36","993":"12ecc613"}[chunkId] + ".css";
};